export default __webpack_public_path__ + "static/media/colorful_rainbow_wall.787b5251.jpg";